export var getReferrer = function (pathname) {
    var referrer = document.referrer;
    var origin = window.location.origin;
    var href = window.location.href;
    var routerReferrer = "".concat(origin).concat(pathname);
    if (referrer === '' && href === routerReferrer) {
        return '';
    }
    else if (referrer !== '' && href === routerReferrer) {
        return referrer;
    }
    else {
        return routerReferrer;
    }
};
